import { atomWithStorage } from 'jotai/vanilla/utils';

/**
 * User state interface
 */
export interface User {
  id: string | null;
  name: string;
  email: string | null;
  isAuthenticated: boolean;
}

/**
 * User profile atom with localStorage persistence
 * Key: spillesammen:user
 */
export const userAtom = atomWithStorage<User>('spillesammen:user', {
  id: null,
  name: 'Guest',
  email: null,
  isAuthenticated: false,
});
